import React, { useState } from 'react';
import NavigationSidebarItem from './NavigationSidebarItem';
import type { NavigationSidebarItem as NavigationSidebarItemType } from './NavigationSidebar';
import './NavigationSidebarItemGroup.scss';
import IconNew from '@hubins/components/IconNew';
import { motion } from "framer-motion";

interface NavigationSidebarItemGroupProps {
  open?: boolean;
  label: string;
  route: string;
  icon?: string;
  items: NavigationSidebarItemType[];
  hideSubItemIcons?: boolean;
  openByDefault?: boolean;
  onOpen?: () => void;
}

const NavigationSidebarItemGroup = ({ label, route, icon, items, hideSubItemIcons = false, openByDefault = false, onOpen, open }: NavigationSidebarItemGroupProps) => {
  const [isOpen, setIsOpen] = useState(openByDefault || open);

  const onClick = () => {
    setIsOpen(!isOpen);
    onOpen?.();
  }

  return (
    <div className="navigation-sidebar-item-group">
      <button className="navigation-sidebar-item-group__label-container" onClick={onClick}>
        <div className="navigation-sidebar-item-group__label-container-inner">
          {icon && <IconNew icon={icon} size={16} />}
          <p className="navigation-sidebar-item-group__label">{label}</p>
        </div>
        <div className={`navigation-sidebar-item-group__label-container-arrow ${isOpen ? 'navigation-sidebar-item-group__label-container-arrow--open' : ''}`}>
          <IconNew icon="arrow down" size={8} />
        </div>
      </button>
      <motion.div className="navigation-sidebar-item-group__items" initial={{ height: 0 }} animate={{ height: isOpen ? 'auto' : 0, opacity: isOpen ? 1 : 0 }} transition={{ duration: 0.2 }}>
        <div className="navigation-sidebar-item-group__items-inner">
          {items.map((item) => (
            <div key={item.route}>
              {item.subItems ? (
                <NavigationSidebarItemGroup label={item.title} route={item.route} icon={item.icon || ''} items={item.subItems} />
              ) : (
                <NavigationSidebarItem label={item.title} to={item.route} icon={hideSubItemIcons ? '' : item.icon} external={item.external} />
              )}
              </div>
            ))}
        </div>
      </motion.div>
    </div>
  );
};

export default NavigationSidebarItemGroup;
